"use strict";

var _interopRequireWildcard = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireWildcard.js");
var _interopRequireDefault = require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime/helpers/interopRequireDefault.js");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regeneratorRuntime2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/regeneratorRuntime.js"));
require("regenerator-runtime/runtime");
var _asyncToGenerator2 = _interopRequireDefault(require("/home/sitc1119/.jenkins/workspace/sitceb-booking-ui-prod/node_modules/@babel/runtime-corejs2/helpers/asyncToGenerator.js"));
var _user = require("@/api/system/user");
var _config = _interopRequireDefault(require("@/utils/config"));
var _auth = require("@/utils/auth");
var _router = _interopRequireWildcard(require("@/router"));
var _ship = require("@/api/standardCode/ship");
var _booking = require("@/api/bookSpace/booking");
var _elementUi = require("element-ui");
var _store = _interopRequireDefault(require("@/store"));
// config

var Base64 = require('js-base64').Base64;
var state = {
  token: (0, _auth.getToken)(),
  userInfo: {},
  roles: [],
  vessel: {},
  btnPermissions: [],
  companyVesselType: [],
  allAssociateVessel: {},
  isHcbUser: false
};
var mutations = {
  SET_TOKEN: function SET_TOKEN(state, token) {
    state.token = token;
  },
  SET_USER_INFO: function SET_USER_INFO(state, userInfo) {
    state.userInfo = userInfo;
  },
  SET_ROLES: function SET_ROLES(state, roles) {
    state.roles = roles;
  },
  SET_VESSEL: function SET_VESSEL(state, vessel) {
    state.vessel = vessel;
  },
  SET_BTN_PERMISSIONS: function SET_BTN_PERMISSIONS(state, permissions) {
    state.btnPermissions = permissions;
  },
  SET_COMPANY_VESSEL_TYPE: function SET_COMPANY_VESSEL_TYPE(state, companyVesselType) {
    state.companyVesselType = companyVesselType;
  },
  SET_ALL_ASSOCIATE_VESSEL: function SET_ALL_ASSOCIATE_VESSEL(state, allAssociateVessel) {
    state.allAssociateVessel = allAssociateVessel;
  },
  IS_HCB_USER: function IS_HCB_USER(state, isHcbUser) {
    state.isHcbUser = isHcbUser;
  }
};
var actions = {
  checkPageAccessPermission: function checkPageAccessPermission(_ref, path) {
    var commit = _ref.commit;
    return new Promise(function (resolve, reject) {
      (0, _booking.checkPageAccessPermission)(path).then(function (response) {
        if (response.success) {
          if (response.result) {
            resolve(response.result);
          } else {
            console.log('response===9999', response);
            var message = _store.default.state.app.language === 'zh' ? '当前账户没有权限查看此页面' : 'The current account does not have permission to view this page';
            _elementUi.Message.warning(message);
            resolve(false);
          }
        }
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // user login
  login: function login(_ref2, userInfo) {
    var commit = _ref2.commit;
    return new Promise(function (resolve, reject) {
      userInfo.password = Base64.encode(userInfo.password);
      (0, _user.login)(userInfo).then(function (response) {
        if (response.success) {
          var data = response.data;
          commit('SET_TOKEN', data.token);
          (0, _auth.setToken)(data.token);
          resolve(response);
        } else {
          reject(response);
        }
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // get user info
  getInfo: function getInfo(_ref3) {
    var commit = _ref3.commit,
      state = _ref3.state,
      dispatch = _ref3.dispatch;
    var path = '/index.html';
    return new Promise(function (resolve, reject) {
      var time = new Date().getTime();
      var data = {};
      data.pageUrl = path;
      data.t = time;
      (0, _user.getInfo)(data).then(function (response) {
        var sessionAttrs = response.sessionAttrs;
        var roles = sessionAttrs.sysRoles;
        // roles must be a non-empty array
        if (roles && roles.length > 0) {
          commit('SET_ROLES', roles);
          // reject('getInfo: roles must be a non-null array!')
        }
        commit('SET_USER_INFO', sessionAttrs.loginUser);
        sessionStorage.setItem("userInfo", JSON.stringify(sessionAttrs.loginUser));
        // getUserPasswordModifyTime(sessionAttrs.loginUser.userId).then(resp => {
        //   const dueData = {}
        //   dueData.modifyTime = resp.data.passwordModifyTime
        //   dueData.appCode = sessionAttrs.loginUser.appCode
        //   if (!dueData.modifyTime) {
        //     dispatch('desktopConfig/showResetPassword', true, {root: true})
        //     dispatch('desktopConfig/mustResetPassword', true, {root: true})
        //   }
        //   isPassDue(dueData).then(res => {
        //     if (res.errorCode === 500001) {
        //       /* 显示 */
        //       dispatch('desktopConfig/showResetPassword', true, {root: true})
        //       dispatch('desktopConfig/mustResetPassword', true, {root: true})
        //     }
        //   })
        // })
        resolve(sessionAttrs);
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // user logout
  logoutAuth: function logoutAuth(_ref4) {
    var _this = this;
    var commit = _ref4.commit,
      state = _ref4.state,
      dispatch = _ref4.dispatch;
    return new Promise(function (resolve, reject) {
      (0, _user.logout)().then(function () {
        commit('SET_TOKEN', '');
        commit('SET_ROLES', []);
        commit('SET_USER_INFO', {});
        (0, _auth.removeToken)();
        (0, _router.resetRouter)();

        // reset visited views and cached views
        // to fixed https://github.com/PanJiaChen/vue-element-admin/issues/2485
        dispatch('tagsView/delAllViews', null, {
          root: true
        });
        resolve();
        _this.$message({
          message: _this.$t('home.logoutSuccess'),
          type: 'success'
        });
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  // remove token
  resetToken: function resetToken(_ref5) {
    var commit = _ref5.commit;
    return new Promise(function (resolve) {
      commit('SET_TOKEN', '');
      commit('SET_ROLES', []);
      (0, _auth.removeToken)();
      resolve();
    });
  },
  // dynamically modify permissions
  changeRoles: function changeRoles(_ref6, role) {
    var commit = _ref6.commit,
      dispatch = _ref6.dispatch;
    return new Promise( /*#__PURE__*/function () {
      var _ref7 = (0, _asyncToGenerator2.default)( /*#__PURE__*/(0, _regeneratorRuntime2.default)().mark(function _callee(resolve) {
        var token, _yield$dispatch, roles, accessRoutes;
        return (0, _regeneratorRuntime2.default)().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              token = role + '-token';
              commit('SET_TOKEN', token);
              (0, _auth.setToken)(token);
              _context.next = 5;
              return dispatch('getInfo');
            case 5:
              _yield$dispatch = _context.sent;
              roles = _yield$dispatch.roles;
              (0, _router.resetRouter)();

              // generate accessible routes map based on roles
              _context.next = 10;
              return dispatch('permission/generateRoutes', roles, {
                root: true
              });
            case 10:
              accessRoutes = _context.sent;
              // dynamically add accessible routes
              _router.default.addRoutes(accessRoutes);

              // reset visited views and cached views
              dispatch('tagsView/delAllViews', null, {
                root: true
              });
              resolve();
            case 14:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref7.apply(this, arguments);
      };
    }());
  },
  /* 判断密码是否过期 */passwordIsDue: function passwordIsDue(_ref8, userInfo) {
    var commit = _ref8.commit;
    return new Promise(function (resolve, reject) {
      (0, _user.isPassDue)(userInfo).then(function (response) {
        if (response.success) {
          resolve(response);
        } else {
          reject(response);
        }
      }).catch(function (error) {
        reject(error);
      });
    });
  },
  /* 船端获取单船信息 */getSingleVessel: function getSingleVessel(_ref9) {
    var commit = _ref9.commit;
    (0, _ship.getSingleVessel)().then(function (res) {
      if (res.success) {
        commit('SET_VESSEL', res.data);
      }
    }).catch(function () {});
  },
  /* 获取按钮权限 */getBtnPermissions: function getBtnPermissions(_ref10) {
    var commit = _ref10.commit;
    var data = {
      appCode: _config.default.appCode
    };
    (0, _user.getBtnPermissions)(data).then(function (res) {
      commit('SET_BTN_PERMISSIONS', res.result);
    });
  }
};
var _default = exports.default = {
  namespaced: true,
  state: state,
  mutations: mutations,
  actions: actions
};